/**
 * RouteSkeleton — generic pending fallback.
 *
 * Used as defaultPendingComponent on createRouter. Renders three vertically-stacked
 * skeleton rows mimicking page header + content, matching the LedgerSkeleton pattern.
 */

import { Skeleton } from '@repo/ui/components/skeleton';

export function RouteSkeleton() {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="পেজ লোড হচ্ছে / Loading page"
      className="flex flex-col gap-4 px-6 pt-8"
    >
      <Skeleton className="h-8 w-48 rounded-sm" />
      <Skeleton className="h-4 w-72 rounded-sm" />
      <Skeleton className="h-64 w-full rounded-sm" />
    </div>
  );
}
